/**
 * @file ImpersonationReasonField.tsx
 * @description Поле «Причина входа» перед входом под сотрудником
 * (phase19.28 этап А; PL17, impersonation.md «Вход в кабинет магазина»):
 * причина обязательна, 5–300 знаков, пишется в журнал магазина и
 * платформы. Счётчик знаков и ошибка — под полем.
 */

import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { IMPERSONATION_REASON_MAX, normalizeImpersonationReason } from "../lib/impersonation-reason";
import { cn } from "@/lib/utils";

interface Props {
  value: string;
  onChange: (value: string) => void;
  /** Ошибка показывается после попытки входа, а не с первой буквы. */
  error: string | null;
  disabled?: boolean;
}

export function ImpersonationReasonField({ value, onChange, error, disabled }: Props) {
  const noteId = "impersonation-reason-note";
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor="impersonation-reason">
        Причина входа<span aria-hidden> *</span>
      </Label>
      <Textarea
        id="impersonation-reason"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        rows={3}
        maxLength={IMPERSONATION_REASON_MAX}
        placeholder="Например: обращение владельца — не уходят письма покупателям"
        aria-required
        aria-invalid={error ? true : undefined}
        aria-describedby={noteId}
        disabled={disabled}
      />
      <p id={noteId} className={cn("type-caption", error ? "text-[var(--destructive-text)]" : "text-on-surface-variant")}>
        {error ?? `Попадёт в журнал магазина и платформы · ${normalizeImpersonationReason(value).length} из ${IMPERSONATION_REASON_MAX}`}
      </p>
    </div>
  );
}
